module.exports = __webpack_public_path__ + "static/media/calor.654a9378.svg";